module.exports = __webpack_public_path__ + "static/media/A1-22-Quazen-cod120.db44a2f7.png";